import { Component, inject } from '@angular/core';
import { NgForOf } from '@angular/common';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { TranslateModule } from '@ngx-translate/core';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import {
  MessageBusEventUtil,
  MessageBusInternalService,
  MessageBusOutgoingEventKey,
  StandardEvent_ExitFeatureToChat
} from '@micro-core/message-bus';
import { RoutingStateService } from '@brightside/brightside-ui-services';
import { ChatService } from '@brightside-web/micro/core/chat';
import { BsChatService } from '@brightside-web/desktop/data-access/core-services';
import { Subscription, take, takeUntil, tap } from 'rxjs';

@Component({
    selector: 'brightside-web-savi',
    imports: [BrightsideUiModule, MicroUiMoleculeModule, TranslateModule, SharedDesktopModule, NgForOf],
    templateUrl: './savi-info.component.html',
    styleUrl: './savi-info.component.scss'
})
export class SaviInfoComponent {

  sub = new Subscription();
  routingStateService = inject(RoutingStateService);
  bgImage = './assets/student-loans-help-bg.png';

  private _chatService = inject(BsChatService);

  goToSavi() {
    MessageBusInternalService.sendOutgoingHubEvent(
      {
        event: MessageBusOutgoingEventKey.ROUTE,
        data: {
          path: 'find-money/intro/savi'
        },
        fallbackSetting: {
          routeToUrl: '/find-money/intro/savi',
        },
      }, 500
    );
  }

  exitToChat() {
    MessageBusInternalService.sendOutgoingHubEvent(
      {
        event: MessageBusOutgoingEventKey.CHAT,
        bridgeSetting: {
          data: {},
        }
      }
    );
    this.sub.add(
      this._chatService.chatLoaded.pipe(
        tap(chat => {
          if (chat) this._chatService.showChat();
        })
      ).subscribe()
    );
  }

  goBackToSplash() {
    this.routingStateService.popAndNavigateTo(['student-loans']);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
